import React, { useEffect, useState } from "react";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import { HomeLearningCard } from "../../components/HomeLearningCard/HomeLearningCard.jsx";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import renderCellExpand from "../../components/rendercellexpand/renderCellExpand.jsx";

export const HomeLearning = () => {
  const columns = [
    {
      field: "school_name",
      headerName: "School",
      flex: 3,
      minWidth: 400,
      renderCell: (params) => (
        <Link
          className="text-[#8884d8] hover:underline"
          to={`/school/${params.row.school_id}`}
        >
          {renderCellExpand(params)}
        </Link>
      ),
    },
    {
      field: "app_student_cnt",
      headerName: "App Student Count",
      minWidth: 50,
      flex: 1,
    },
    {
      field: "app_logged_in_student",
      headerName: "Student Logged In",
      minWidth: 10,
      flex: 1,
    },
  ];

  const { user } = useAuth();
  const school_types = user.view_access_list.school_types
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  const district_names = user.view_access_list.district
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  const [homeLearningKPIData, setHomeLearningKPIData] = useState();
  const [
    homeLearningSummaryListByDistrict,
    setHomeLearningSummaryListByDistrict,
  ] = useState();
  const [
    homeLearningSummaryListByDistrictGraph,
    setHomeLearningSummaryListByDistrictGraph,
  ] = useState();
  const [, setStudentsNotLoggedIn] = useState();
  const [schoolGraphData, setSchoolGraphData] = useState();

  const getHomeLearningData = async () => {
    try {
      const res = await axiosInstance.post("/getHomeLearningKPIByDistrict", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        district_names: district_names,
        school_types: school_types,
      });
      setHomeLearningKPIData(res.data.data.home_learning_kpi);
    } catch (err) {
      alert(err.message);
    }
  };

  const getHomeLearningSummaryListByDistrict = async () => {
    try {
      const res = await axiosInstance.post(
        "/getHomeLearningSummaryListByDistrict",
        {
          user_id: user.user_id,
          auth_token: user.auth_token,
          district_names: district_names,
          school_types: school_types,
        }
      );
      setHomeLearningSummaryListByDistrict(res.data.data.home_learning_summary);
    } catch (err) {
      alert(err.message);
    }
  };

  const getHomeLearningSummaryListByDistrictGraph = async () => {
    try {
      const res = await axiosInstance.post(
        "getHomeLearningSummaryListByDistrictGraph",
        {
          user_id: user.user_id,
          auth_token: user.auth_token,
          district_names: district_names,
          school_types: school_types,
        }
      );
      setHomeLearningSummaryListByDistrictGraph(
        res.data.data.home_learning_summary_graph
      );
      setSchoolGraphData({
        labels: res.data.data.home_learning_summary_graph.map(
          (school) => school.school_name
        ),
        datasets: [
          {
            label: "Percentage Logged In",
            data: res.data.data.home_learning_summary_graph.map(
              (school) => school.Percent_logged_in
            ),
          },
        ],
      });
    } catch (err) {
      alert(err.message);
    }
  };

  const getStudentsNotLoggedIn = async () => {
    try {
      const res = await axiosInstance.post("/getStudentsNotLoggedin", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        district_names: district_names,
        school_types: school_types,
      });
      setStudentsNotLoggedIn(res.data.data.student_not_logged_in);
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    getHomeLearningData();
    getHomeLearningSummaryListByDistrict();
    getHomeLearningSummaryListByDistrictGraph();
    getStudentsNotLoggedIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="homelearning-container">
      {homeLearningKPIData && <HomeLearningCard data={homeLearningKPIData} />}

      {homeLearningSummaryListByDistrict && (
        <DataGrid
          columns={columns}
          rows={homeLearningSummaryListByDistrict}
          rowHeight={50}
          sx={{ marginTop: "2.5em" }}
          autoHeight={true}
          getRowId={(row) => row.school_id}
          // components={{
          //   Toolbar: CustomToolbar,
          // }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      )}

      {homeLearningSummaryListByDistrictGraph && (
        <Bar
          data={schoolGraphData}
          options={{
            scales: {
              x: {
                categoryPercentage: 1.0,
              },
              y: {
                beginAtZero: true,
              },
            },
          }}
        />
      )}
    </div>
  );
};
